// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/modal.css
// module id = 80
// module chunks = 1